import CustomBreadcrumb from "components/CustomBreadcrumb";
import SC from "./style";
import { Tabs } from "@InnoUI/";
import { useEffect, useState } from "react";
import theme from "@theme/";
import GeneralInformationForm from "views/AdminSettings/Projects/Occupant/GeneralInformationForm";
import { useSelector } from "react-redux";
import ContactInformation from "./ContactInformation";
import GetPermission from "../ListFileAndPermission/FileDetailsView/GetPermission";
import { useSearchParams } from "react-router-dom";
import OccupantFilterDropdown from "components/OccupantFilterDropdown";
import CheckPermissionWrapper from "components/CheckPermissionWrapper";
import { userAccessType } from "utils/lookUpTable";
import { apiGet } from "api/callApi";

const OcuupantInfo = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [searchParams] = useSearchParams();
  const folderId = searchParams.get("folderId");

  const currentProject = useSelector(
    (state) => state?.currentProject?.data || []
  );

  const currentOccupant = useSelector(
    (state) => state?.currentOccupant?.data || []
  );
  const handleTabChange = (event, value) => {
    setSelectedTab(value);
  };

  const tabData = [
    { value: 0, label: "General Information" },
    // { value: 1, label: "Contact Information" },
  ];

  return (
    <>
      <CustomBreadcrumb />

      <div style={{ marginTop: "50px" }}>
        <SC.FilterContainer>
          <OccupantFilterDropdown />
        </SC.FilterContainer>
      </div>

      <CheckPermissionWrapper>
        {({ permission }) => (
          <>
            <SC.LeasingLayout>
              <GetPermission folderId={folderId} />
            </SC.LeasingLayout>

            <div
              style={{
                marginLeft: "15px",
                borderBottom: `1px solid ${theme.colors.bordertask}`,
              }}
            >
              <Tabs
                value={selectedTab}
                label={tabData.map((tab) => tab.label)}
                onChange={handleTabChange}
                selectedValue={selectedTab}
              />
            </div>
            {selectedTab === 0 && (
              <SC.CardContainerStyle>
                <GeneralInformationForm
                  occupantdata={currentOccupant}
                  Projectdata={currentProject}
                  levelId={currentOccupant.levelId}
                  rowId={currentOccupant.id}
                  //   fetchData={fetchData}
                  isEditing={true}
                  isInfo={true}
                  hideButtons={
                    permission == userAccessType.write ? false : true
                  }
                />
              </SC.CardContainerStyle>
            )}
            {/* {selectedTab === 1 && (
              <SC.CardContainerStyle>
                <ContactInformation
                  hideButtons={
                    permission == userAccessType.write ? false : true
                  }
                />
              </SC.CardContainerStyle>
            )} */}
          </>
        )}
      </CheckPermissionWrapper>
    </>
  );
};

export default OcuupantInfo;
